import { Box } from '@/components/ui/box'
import { SkeletonText } from '@/components/ui/skeleton'

const DetailsSkeleton = () => {
    return (
        <Box ml="24px" mt="24px">
            <Box mb="12px">
                <SkeletonText noOfLines={1} gap="1" skeletonHeight="4" width="30%" />
                <SkeletonText mt="8px" noOfLines={1} gap="1" skeletonHeight="4" width="90%" />
            </Box>
            <Box mb="12px">
                <SkeletonText noOfLines={1} gap="1" skeletonHeight="4" width="25%" />
                <SkeletonText mt="8px" noOfLines={1} gap="1" skeletonHeight="4" width="65%" />
            </Box>
            <Box mb="12px">
                <SkeletonText noOfLines={1} gap="1" skeletonHeight="4" width="34%" />
                <SkeletonText mt="8px" noOfLines={1} gap="1" skeletonHeight="4" width="75%" />
            </Box>
            <Box mb="12px">
                <SkeletonText noOfLines={1} gap="1" skeletonHeight="4" width="27%" />
                <SkeletonText mt="8px" noOfLines={1} gap="1" skeletonHeight="4" width="85%" />
            </Box>
            <Box mb="12px">
                <SkeletonText noOfLines={1} gap="1" skeletonHeight="4" width="32%" />
                <SkeletonText mt="8px" noOfLines={1} gap="1" skeletonHeight="4" width="68%" />
            </Box>
        </Box>
    )
}

export default DetailsSkeleton
